$(document).ready(function(){
$(".quantity__button").on("click",function(){
  var pdp_qty_value = parseInt($(".product__info-container .product-form__quantity quantity-input input").val());
  console.log("pdp_qty_value:--",pdp_qty_value);
  var pdp_ticket = $(".price_with_cst_data .cus_ticket").data("ticket");
  $(".cus_ticket").text(pdp_ticket*pdp_qty_value);
  $("#form_ticket").val(pdp_ticket*pdp_qty_value+" Entrate");
  // console.log(pdp_ticket*pdp_qty_value);

});

  

  function calculateTotalTickets() {
      jQuery.getJSON('/cart.js', function(cart) {
      // console.log("in custom.js");
       let totalTickets = 0;
     // now have access to Shopify cart object
      $(".cart-item").each(function(){
         var total_ticket = $(this).find(".cus_tickitnumber").data("ticket_no");
            if (!isNaN(total_ticket)) {
              totalTickets += parseInt(total_ticket, 10);
          }
      });
      // console.log(totalTickets);
      $(".totaal-ticket-count").text(totalTickets+" Entrate");
  });
  }

  const intervalId = setInterval(calculateTotalTickets, 1000);

  // Stop after 5 seconds
  // setTimeout(() => {
  //   clearInterval(intervalId);
  //   console.log("Interval cleared after 5 seconds");
  // }, 5000);

  //     jQuery.getJSON('/cart.js', function(cart) {
  //     console.log("in custom.js")
  //      let totalTickets = 0;
  //    // now have access to Shopify cart object
  //     $(".cart-item").each(function(){
  //        var total_ticket = $(this).find(".cus_tickitnumber").data("ticket_no");
  //           if (!isNaN(total_ticket)) {
  //             totalTickets += parseInt(total_ticket, 10);
  //         }
  //     });
  //     console.log(totalTickets);
  //     $(".totaal-ticket-count").text(totalTickets+" Tickets");
  // });



});





$(document).ready(function(){
$(".cst_pay_btn").on("click",function(){
  $(".cart__checkout-button.button").trigger("click");
});
});


$(document).ready(function() {  
    var maxHeight = 0;  
    
    // Find the maximum height  
    $('.custom-featured-collection .card__information .card__heading').each(function() {  
        var thisHeight = $(this).innerHeight();  
        if (thisHeight > maxHeight) {  
            maxHeight = thisHeight;  
        }  
    });  
    
    // Set all divs to the maximum height  
    $('.custom-featured-collection .card__information .card__heading').css('height', maxHeight + 'px');  
});


const thumbSwiper = new Swiper('.swiprt_thumbnail_slider', {
  slidesPerView: 4,
  spaceBetween: 26,
  slideThumbActiveClass: 'swiper-slide-thumb-active',
  // navigation: {
  //     nextEl: '.swiper-button-next.thumb',
  //     prevEl: '.swiper-button-prev.thumb'
  //   }

});

const mainSlider = new Swiper('.swiper.slider-mobile-gutter', {
  slidesPerView: 1,
  autoHeight: true,
  spaceBetween: 0,
  effect: 'slide',
  watchOverflow: true,
  speed: 500,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true
  },
  thumbs: {
    swiper: thumbSwiper
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }

});

